exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sss-schedules {\r\n  position: relative;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component.css
// module id = ./src/app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component.css
// module chunks = main